import React, { useState, useEffect, useCallback } from "react";
import { useParams, useLocation, Link } from "react-router-dom";
import axios from "axios";
import { MdVerified } from "react-icons/md";
import FooterDashboard from "./footer.dashboard";
import DashSearchHeader from "./header.search.dashboard";
import DashMenu from "./dash_menu";
import { FaRegTimesCircle } from "react-icons/fa";

const PaymentVerify = () => {
    const { course_id } = useParams();
    const location = useLocation();
    const [verificationResult, setVerificationResult] = useState("successful");
    const [error, setError] = useState(null);
    const [reference, setReference] = useState(null); // State to store the extracted reference

    const getInitialMenuCoverWidth = () => {
        const windowWidth = window.innerWidth;
        if (windowWidth < 900) {
            return 0;
        } else if (windowWidth >= 900 && windowWidth < 1200) {
            return 60;
        } else {
            return 260;
        }
    };
    const [menuCoverWidth, setMenuCoverWidth] = useState(getInitialMenuCoverWidth());

    const handleResize = useCallback(() => {
        const menuCover = document.querySelector('.dashboard .menu_cover');
        if (menuCover) {
            setMenuCoverWidth(menuCover.offsetWidth);
        }
    }, []);

    useEffect(() => {
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [handleResize]);

    useEffect(() => {
      const searchParams = new URLSearchParams(location.search);
      const extractedReference = searchParams.get('reference'); // Or 'trxref'

      if (extractedReference) {
          setReference(extractedReference);
      }
    }, [location.search]);

    const handleVerifyPayment = useCallback(async (ref) => {
        const accessToken = localStorage.getItem("accessToken");
        const ID = course_id;
        console.log(ID, ref);
        console.log("checking the main link", ref);

        try {
            const response = await axios.get(
                `https://api.geoinfoacademy.com/api/payment/verify/?reference=${ref}`,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );
            console.log("Payment Verification Response:", response.data);
            setVerificationResult(response.data);
            setError(null);
        } catch (err) {
            console.error("Error verifying payment:", err);
            setError(err.response?.data?.message || "Payment verification failed.");
            setVerificationResult(null);
        }
    }, [course_id]);

    useEffect(() => {
        if (reference) {
            handleVerifyPayment(reference);
        }
    }, [reference, handleVerifyPayment]);

    return (
        <div className="dashboard">
            <DashSearchHeader onResize={handleResize} />
            <DashMenu />
            <div className="dash_body" style={{ width: `calc(100% - ${menuCoverWidth}px - 8px)` }}>
                <div className="PaymentVerify">
                    {verificationResult ? (
                        <div className="payment_container">
                            <div className="image">
                                <MdVerified className="good" />
                            </div>
                            <br />
                            <h4>Payment Successful!</h4>
                            {/* <p>{JSON.stringify(verificationResult)}</p> */}
                            <Link to={"/description/" + course_id}><button>Back to Course</button></Link>
                        </div>
                    ) : error ? (
                        <div className="payment_container">
                            <div className="image">
                                <FaRegTimesCircle className="failed" />
                            </div>
                            <br />
                            <h4>Payment Failed!</h4>
                            {/* <p>{error}</p> */}
                            <Link to={"/description/" + course_id}><button>Back to Course</button></Link>
                        </div>
                    ) : (
                        <div className="no_course">
                            <p>Verifying Payment...</p>
                        </div>
                    )}
                </div>
                <FooterDashboard />
            </div>
        </div>
    );
};

export default PaymentVerify;